var _text, _text2, _text3, _ellipse, _ellipse2, _ellipse3, _rect, _rect2, _rect3, _rect4, _text4, _text5, _text6, _text7, _text8, _text9, _text10, _text11, _line, _line2, _text12, _text13, _text14, _line3, _text15, _text16, _text17, _text18, _line4, _text19, _line5, _text20, _line6, _line7, _line8, _line9, _line10, _line11, _line12, _line13, _line14, _line15, _line16, _line17, _rect5, _rect6, _text21, _rect7, _rect8, _text22, _text23, _ellipse4, _ellipse5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgReviewsPlot(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "100%",
    height: 297.071,
    viewBox: "0 0 306.623 297.071",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Group_3098",
    "data-name": "Group 3098",
    transform: "translate(-1444.063 -1353.44)"
  }, _text || (_text = /*#__PURE__*/React.createElement("text", {
    id: "Your_Original_Rank",
    "data-name": "Your Original Rank",
    transform: "translate(1567.028 1363.44)",
    fill: "#7f7f7f",
    fontSize: 10,
    fontFamily: "Roboto-Regular, Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Your Original Rank"))), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    id: "Your_Current_Rank",
    "data-name": "Your Current Rank",
    transform: "translate(1464.479 1363.44)",
    fill: "#7f7f7f",
    fontSize: 10,
    fontFamily: "Roboto-Regular, Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Your Current Rank"))), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    id: "Top_Competitor",
    "data-name": "Top Competitor",
    transform: "translate(1670.599 1363.44)",
    fill: "#7f7f7f",
    fontSize: 10,
    fontFamily: "Roboto-Regular, Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Top Competitor"))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_341",
    "data-name": "Ellipse 341",
    cx: 4.688,
    cy: 4.688,
    rx: 4.688,
    ry: 4.688,
    transform: "translate(1444.063 1354.763)",
    fill: "#e27867"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_342",
    "data-name": "Ellipse 342",
    cx: 4.688,
    cy: 4.688,
    rx: 4.688,
    ry: 4.688,
    transform: "translate(1553.063 1354.763)",
    fill: "#74ad85"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_343",
    "data-name": "Ellipse 343",
    cx: 4.688,
    cy: 4.688,
    rx: 4.688,
    ry: 4.688,
    transform: "translate(1657.063 1354.763)",
    fill: "#98c3ac",
    opacity: 0.745
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1568",
    "data-name": "Rectangle 1568",
    width: 51.758,
    height: 29.758,
    transform: "translate(1504.545 1381.901)",
    fill: "#e6e7e8"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1569",
    "data-name": "Rectangle 1569",
    width: 71.459,
    height: 67.198,
    transform: "translate(1673.26 1381.901)",
    fill: "#fff",
    opacity: 0.1
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1570",
    "data-name": "Rectangle 1570",
    width: 50.58,
    height: 150.016,
    transform: "translate(1504.576 1411.198)",
    fill: "#99c2ad",
    opacity: 0.602
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1571",
    "data-name": "Rectangle 1571",
    width: 188.459,
    height: 150.229,
    transform: "translate(1556.26 1411.491)",
    fill: "#ebf3ee",
    opacity: 0.997
  })), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    id: "Number_of_Google_reviews",
    "data-name": "Number of Google reviews",
    transform: "translate(1611.021 1597.806)",
    fill: "#7f7f7f",
    fontSize: 10,
    fontFamily: "Roboto-Regular, Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -58.855,
    y: 0
  }, "Number of Google reviews"))), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    id: "Average_rating",
    "data-name": "Average rating",
    transform: "translate(1459.751 1482.621) rotate(-90)",
    fill: "#7f7f7f",
    fontSize: 10,
    fontFamily: "Roboto-Regular, Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -31.941,
    y: 0
  }, "Average rating"))), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    id: "_200",
    "data-name": 200,
    transform: "translate(1630.511 1577.153)",
    fill: "#7f7f7f",
    fontSize: 10,
    fontFamily: "Roboto-Regular, Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -16.846,
    y: 0
  }, "200"))), _text7 || (_text7 = /*#__PURE__*/React.createElement("text", {
    id: "_300",
    "data-name": 300,
    transform: "translate(1690.598 1577.154)",
    fill: "#7f7f7f",
    fontSize: 10,
    fontFamily: "Roboto-Regular, Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -16.846,
    y: 0
  }, "300"))), _text8 || (_text8 = /*#__PURE__*/React.createElement("text", {
    id: "_400",
    "data-name": 400,
    transform: "translate(1750.687 1577.155)",
    fill: "#7f7f7f",
    fontSize: 10,
    fontFamily: "Roboto-Regular, Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -16.846,
    y: 0
  }, "400"))), _text9 || (_text9 = /*#__PURE__*/React.createElement("text", {
    id: "_0",
    "data-name": 0,
    transform: "translate(1505.852 1577.152)",
    fill: "#7f7f7f",
    fontSize: 10,
    fontFamily: "Roboto-Regular, Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -5.615,
    y: 0
  }, "0"))), _text10 || (_text10 = /*#__PURE__*/React.createElement("text", {
    id: "_100",
    "data-name": 100,
    transform: "translate(1570.421 1577.153)",
    fill: "#7f7f7f",
    fontSize: 10,
    fontFamily: "Roboto-Regular, Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -16.846,
    y: 0
  }, "100"))), _text11 || (_text11 = /*#__PURE__*/React.createElement("text", {
    id: "_4.1",
    "data-name": 4.1,
    transform: "translate(1488 1564)",
    fill: "#7f7f7f",
    fontSize: 10,
    fontFamily: "Roboto-Regular, Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -6.931,
    y: 0
  }, "4.1"))), _line || (_line = /*#__PURE__*/React.createElement("line", {
    id: "Line_205",
    "data-name": "Line 205",
    y1: 179.819,
    transform: "translate(1504.545 1381.901)",
    fill: "none",
    stroke: "#a7a9ac",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    id: "Line_206",
    "data-name": "Line 206",
    y1: 179.819,
    transform: "translate(1555.884 1381.901)",
    fill: "none",
    stroke: "#7f7f7f",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })), _text12 || (_text12 = /*#__PURE__*/React.createElement("text", {
    id: "_4.5",
    "data-name": 4.5,
    transform: "translate(1488.369 1485)",
    fill: "#7f7f7f",
    fontSize: 10,
    fontFamily: "Roboto-Regular, Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -6.931,
    y: 0
  }, "4.5"))), _text13 || (_text13 = /*#__PURE__*/React.createElement("text", {
    id: "_4.8",
    "data-name": 4.8,
    transform: "translate(1488.369 1425)",
    fill: "#7f7f7f",
    fontSize: 10,
    fontFamily: "Roboto-Regular, Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -6.931,
    y: 0
  }, "4.8"))), _text14 || (_text14 = /*#__PURE__*/React.createElement("text", {
    id: "_4.9",
    "data-name": 4.9,
    transform: "translate(1488.369 1405)",
    fill: "#7f7f7f",
    fontSize: 10,
    fontFamily: "Roboto-Regular, Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -6.931,
    y: 0
  }, "4.9"))), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    id: "Line_207",
    "data-name": "Line 207",
    y1: 179.819,
    transform: "translate(1624.232 1381.901)",
    fill: "none",
    stroke: "#a7a9ac",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  })), _text15 || (_text15 = /*#__PURE__*/React.createElement("text", {
    id: "_4.4",
    "data-name": 4.4,
    transform: "translate(1488.369 1505)",
    fill: "#7f7f7f",
    fontSize: 10,
    fontFamily: "Roboto-Regular, Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -6.931,
    y: 0
  }, "4.4"))), _text16 || (_text16 = /*#__PURE__*/React.createElement("text", {
    id: "_4.7",
    "data-name": 4.7,
    transform: "translate(1488.369 1445)",
    fill: "#7f7f7f",
    fontSize: 10,
    fontFamily: "Roboto-Regular, Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -6.931,
    y: 0
  }, "4.7"))), _text17 || (_text17 = /*#__PURE__*/React.createElement("text", {
    id: "_4.3",
    "data-name": 4.3,
    transform: "translate(1488.369 1524)",
    fill: "#7f7f7f",
    fontSize: 10,
    fontFamily: "Roboto-Regular, Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -6.931,
    y: 0
  }, "4.3"))), _text18 || (_text18 = /*#__PURE__*/React.createElement("text", {
    id: "_4.6",
    "data-name": 4.6,
    transform: "translate(1488.369 1465)",
    fill: "#7f7f7f",
    fontSize: 10,
    fontFamily: "Roboto-Regular, Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -6.931,
    y: 0
  }, "4.6"))), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    id: "Line_208",
    "data-name": "Line 208",
    y1: 179.819,
    transform: "translate(1564.389 1381.901)",
    fill: "none",
    stroke: "#a7a9ac",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  })), _text19 || (_text19 = /*#__PURE__*/React.createElement("text", {
    id: "_4.2",
    "data-name": 4.2,
    transform: "translate(1488 1544)",
    fill: "#7f7f7f",
    fontSize: 10,
    fontFamily: "Roboto-Regular, Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -6.931,
    y: 0
  }, "4.2"))), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    id: "Line_209",
    "data-name": "Line 209",
    y1: 179.819,
    transform: "translate(1684.075 1381.901)",
    fill: "none",
    stroke: "#a7a9ac",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  })), _text20 || (_text20 = /*#__PURE__*/React.createElement("text", {
    id: "_5.0",
    "data-name": 5,
    transform: "translate(1488.369 1385)",
    fill: "#7f7f7f",
    fontSize: 10,
    fontFamily: "Roboto-Regular, Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -6.931,
    y: 0
  }, "5.0"))), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    id: "Line_210",
    "data-name": "Line 210",
    y1: 179.819,
    transform: "translate(1743.919 1381.901)",
    fill: "none",
    stroke: "#a7a9ac",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    id: "Line_211",
    "data-name": "Line 211",
    x2: 240.241,
    transform: "translate(1504.479 1483.604)",
    fill: "none",
    stroke: "#a7a9ac",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    id: "Line_212",
    "data-name": "Line 212",
    x2: 240.241,
    transform: "translate(1504.479 1463.144)",
    fill: "none",
    stroke: "#a7a9ac",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    id: "Line_213",
    "data-name": "Line 213",
    x2: 240.241,
    transform: "translate(1504.479 1441.974)",
    fill: "none",
    stroke: "#a7a9ac",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    id: "Line_214",
    "data-name": "Line 214",
    x2: 240.241,
    transform: "translate(1504.479 1422.223)",
    fill: "none",
    stroke: "#a7a9ac",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  })), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    id: "Line_215",
    "data-name": "Line 215",
    x2: 240.241,
    transform: "translate(1504.479 1411.684)",
    fill: "none",
    stroke: "#7f7f7f",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })), _line12 || (_line12 = /*#__PURE__*/React.createElement("line", {
    id: "Line_216",
    "data-name": "Line 216",
    x2: 240.241,
    transform: "translate(1504.479 1404.753)",
    fill: "none",
    stroke: "#a7a9ac",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  })), _line13 || (_line13 = /*#__PURE__*/React.createElement("line", {
    id: "Line_217",
    "data-name": "Line 217",
    x2: 240.241,
    transform: "translate(1504.479 1382.291)",
    fill: "none",
    stroke: "#a7a9ac",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  })), _line14 || (_line14 = /*#__PURE__*/React.createElement("line", {
    id: "Line_218",
    "data-name": "Line 218",
    x2: 240.241,
    transform: "translate(1504.479 1561.531)",
    fill: "none",
    stroke: "#a7a9ac",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  })), _line15 || (_line15 = /*#__PURE__*/React.createElement("line", {
    id: "Line_219",
    "data-name": "Line 219",
    x2: 240.241,
    transform: "translate(1504.479 1524.525)",
    fill: "none",
    stroke: "#a7a9ac",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  })), _line16 || (_line16 = /*#__PURE__*/React.createElement("line", {
    id: "Line_220",
    "data-name": "Line 220",
    x2: 240.241,
    transform: "translate(1504.479 1544.985)",
    fill: "none",
    stroke: "#a7a9ac",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  })), _line17 || (_line17 = /*#__PURE__*/React.createElement("line", {
    id: "Line_221",
    "data-name": "Line 221",
    x2: 240.241,
    transform: "translate(1504.479 1504.065)",
    fill: "none",
    stroke: "#a7a9ac",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1715",
    "data-name": "Rectangle 1715",
    width: 24.37,
    height: 21.177,
    transform: "translate(1701.691 1610.099)",
    fill: "none",
    stroke: "#aeb0b3",
    strokeMiterlimit: 10,
    strokeWidth: 0.858,
    opacity: 0.3
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1717",
    "data-name": "Rectangle 1717",
    width: 24.37,
    height: 21.177,
    transform: "translate(1608.964 1609.788)",
    fill: "#ebf3ee"
  })), _text21 || (_text21 = /*#__PURE__*/React.createElement("text", {
    id: "Ideal",
    transform: "translate(1713.956 1647.511)",
    fill: "#7f7f7f",
    fontSize: 10,
    fontFamily: "Roboto-Black, Roboto",
    fontWeight: 800
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -13.655,
    y: 0
  }, "IDEAL"))), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1714",
    "data-name": "Rectangle 1714",
    width: 24.37,
    height: 21.177,
    transform: "translate(1579.691 1609.788)",
    fill: "#e6e7e8"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1716",
    "data-name": "Rectangle 1716",
    width: 24.37,
    height: 21.177,
    transform: "translate(1480.691 1609.898)",
    fill: "#99c2ad",
    opacity: 0.602
  })), _text22 || (_text22 = /*#__PURE__*/React.createElement("text", {
    id: "Average",
    transform: "translate(1607.956 1647.511)",
    fill: "#7f7f7f",
    fontSize: 10,
    fontFamily: "Roboto-Black, Roboto",
    fontWeight: 800
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -22.192,
    y: 0
  }, "AVERAGE"))), _text23 || (_text23 = /*#__PURE__*/React.createElement("text", {
    id: "Poor",
    transform: "translate(1491.956 1647.511)",
    fill: "#7f7f7f",
    fontSize: 10,
    fontFamily: "Roboto-Black, Roboto",
    fontWeight: 800
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -13.42,
    y: 0
  }, "POOR"))), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_393",
    "data-name": "Ellipse 393",
    cx: 5.614,
    cy: 5.614,
    rx: 5.614,
    ry: 5.614,
    transform: "translate(1620.683 1385.198)",
    fill: "#e6e7e8",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_407",
    "data-name": "Ellipse 407",
    cx: 5.614,
    cy: 5.614,
    rx: 5.614,
    ry: 5.614,
    transform: "translate(1655.683 1395.198)",
    fill: "#98c3ac",
    opacity: 0.745,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_394",
    "data-name": "Ellipse 394",
    cx: 5.614,
    cy: 5.614,
    rx: 5.614,
    ry: 5.614,
    transform: "translate(1594.161 1412.99)",
    fill: "#e6e7e8",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_395",
    "data-name": "Ellipse 395",
    cx: 5.614,
    cy: 5.614,
    rx: 5.614,
    ry: 5.614,
    transform: "translate(1559.724 1395.14)",
    fill: "#e6e7e8",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_396",
    "data-name": "Ellipse 396",
    cx: 5.614,
    cy: 5.614,
    rx: 5.614,
    ry: 5.614,
    transform: "translate(1526.724 1407.14)",
    fill: "#e6e7e8",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_397",
    "data-name": "Ellipse 397",
    cx: 5.614,
    cy: 5.614,
    rx: 5.614,
    ry: 5.614,
    transform: "translate(1517.724 1450.14)",
    fill: "#e6e7e8",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_398",
    "data-name": "Ellipse 398",
    cx: 5.614,
    cy: 5.614,
    rx: 5.614,
    ry: 5.614,
    transform: "translate(1531.724 1478.14)",
    fill: "#e6e7e8",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_399",
    "data-name": "Ellipse 399",
    cx: 5.614,
    cy: 5.614,
    rx: 5.614,
    ry: 5.614,
    transform: "translate(1520.724 1389.14)",
    fill: "#e6e7e8",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_400",
    "data-name": "Ellipse 400",
    cx: 5.614,
    cy: 5.614,
    rx: 5.614,
    ry: 5.614,
    transform: "translate(1537.724 1379.14)",
    fill: "#e6e7e8",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_401",
    "data-name": "Ellipse 401",
    cx: 5.614,
    cy: 5.614,
    rx: 5.614,
    ry: 5.614,
    transform: "translate(1516.724 1417.14)",
    fill: "#e6e7e8",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_402",
    "data-name": "Ellipse 402",
    cx: 5.614,
    cy: 5.614,
    rx: 5.614,
    ry: 5.614,
    transform: "translate(1506.724 1413.14)",
    fill: "#e6e7e8",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_403",
    "data-name": "Ellipse 403",
    cx: 5.614,
    cy: 5.614,
    rx: 5.614,
    ry: 5.614,
    transform: "translate(1501.724 1423.14)",
    fill: "#e6e7e8",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_404",
    "data-name": "Ellipse 404",
    cx: 5.614,
    cy: 5.614,
    rx: 5.614,
    ry: 5.614,
    transform: "translate(1590.146 1400.048)",
    fill: "#e6e7e8",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_405",
    "data-name": "Ellipse 405",
    cx: 5.614,
    cy: 5.614,
    rx: 5.614,
    ry: 5.614,
    transform: "translate(1731.136 1377.212)",
    fill: "#e27867"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_406",
    "data-name": "Ellipse 406",
    cx: 5.614,
    cy: 5.614,
    rx: 5.614,
    ry: 5.614,
    transform: "translate(1503.555 1377.572)",
    fill: "#72ae84"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReviewsPlot);
export default __webpack_public_path__ + "static/media/reviewsPlot.a4c51eab.svg";
export { ForwardRef as ReactComponent };